import { createApp, VueElement, Vue } from "vue";
import PrimeVue from "primevue/config";
// import ToastService from "primevue/toastservice";
import App from "./App.vue";
import router from "./router";
import $$vm from "./data/index";
import disableDevtool from "disable-devtool";
import NoSleep from "nosleep.js";
import Vue3Marquee from "vue3-marquee";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import Tooltip from "primevue/tooltip";
import Lara from '@primeuix/themes/lara';

$$vm.clientdata.ua = window.navigator.userAgent;
$$vm.clientdata.uadone = true;
// FingerprintJS.load()//   .then((fp) => fp.get())
//   .then((result) => {
//     const visitorId = result.visitorId;
//     $$vm.clientdata.fingerprint = visitorId;
//     $$vm.clientdata.fingerprintdone = true;
//   });
// $.getJSON("https://api.ipify.org?format=jsonp&callback=?", function (json) {
//   $$vm.clientdata.ip = json.ip;
//   $$vm.clientdata.ip1done = true;
// });
// $.getJSON("https://api64.ipify.org?format=jsonp&callback=?", function (json) {
//   $$vm.clientdata.ip6 = json.ip;
//   $$vm.clientdata.ip6done = true;
// });
// $.getJSON("https://api.country.is/", function (json) {
//   $$vm.clientdata.ip1 = json.ip;
//   $$vm.clientdata.country = json.country;
//   $$vm.clientdata.ip1done = true;
//   $$vm.clientdata.countrydone = true;
// });
setInterval(function () {
  if ($$vm.clientdata.ua !== window.navigator.userAgent) {
    $$vm.clientdata.ua = window.navigator.userAgent;
    //window.location = window.location.origin + "/developer-tools";
  } else {
    $$vm.clientdata.ua = window.navigator.userAgent;
  }
  //console.log(navigator.userAgentData);
  navigator.userAgentData.getHighEntropyValues(["model"]).then((ua) => {
    // requested hints available as attributes
    const model = ua.model;
  });
  //var startTime = performance.now();
  var start = +new Date();
  //debugger;
  //var stopTime = performance.now();
  var allow = 100;
  var end = +new Date();
  //if (stopTime - startTime > 100) {
  if (isNaN(start) || isNaN(end) || end - start > allow) {
    //window.location = window.location.origin + "/developer-tools";
  }
}, 1000);
$(document).on("click", ".nav .nav-item", function () {
  centerItFixedWidth($(this), $(this).parent());
});

function centerItFixedWidth(target, outer) {
  var out = $(outer);
  var tar = $(target);
  var x = out.width();
  var y = tar.outerWidth(true);
  var z = tar.index();
  var q = 0;
  var m = out.find("li");
  //Just need to add up the width of all the elements before our target.
  for (var i = 0; i < z; i++) {
    q += $(m[i]).outerWidth(true);
  }
  out.animate(
    {
      scrollLeft: Math.max(0, q - (x - y) / 2),
    },
    300
  );
}
$(window).scroll(function () {
  if ($(this).scrollTop() > 125) {
    $(".right-sidebar").addClass("sticky");
  }
  if ($(this).scrollTop() < 125) {
    $(".right-sidebar").removeClass("sticky");
  }
});
$(window).ready(function () {
  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });
});
toastr.options = { closeButton: true, debug: false, newestOnTop: false, progressBar: false, positionClass: "toast-top-center", preventDuplicates: false, onclick: null, showDuration: "300", hideDuration: "1000", timeOut: "3000", extendedTimeOut: "1000", showEasing: "swing", hideEasing: "linear", showMethod: "fadeIn", hideMethod: "fadeOut" };
var noSleep = new NoSleep();
document.addEventListener(
  "click",
  function enableNoSleep() {
    document.removeEventListener("click", enableNoSleep, false);
    noSleep.enable();
  },
  false
);
var app = createApp(App);
// https://geolocation-db.com/json/86f5f280-f4eb-11ec-8676-4f4388bc6daa

$$vm.shortNumber = function (number) {
  if (number) {
    var abs = Math.abs(number);
    if (abs >= Math.pow(10, 12)) {
      // trillion
      number = (number / Math.pow(10, 12)).toFixed(1) + " T";
      return number;
    } else if (abs < Math.pow(10, 12) && abs >= Math.pow(10, 9)) {
      // billion
      number = (number / Math.pow(10, 9)).toFixed(1) + " B";
      return number;
    } else if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6)) {
      // million
      number = (number / Math.pow(10, 6)).toFixed(1) + " M";
      if (number === "1.0 M") {
        number = "10L";
      }
      if (number === "2.0 M") {
        number = "20L";
      }
      if (number === "2.5 M") {
        number = "25L";
      }
      if (number === "3.0 M") {
        number = "30L";
      }
      if (number === "4.0 M") {
        number = "40L";
      }
      if (number === "5.0 M") {
        number = "50L";
      }
      if (number === "10.0 M") {
        number = "100L";
      }
      return number;
    } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 3)) {
      // thousand
      number = (number / Math.pow(10, 3)).toFixed(1) + "K";
      if (number.endsWith(".0K")) {
        number = number.replace(".0", "");
      }
      if (number === "100.0K" || number === "100K") {
        number = "1L";
      }
      if (number === "200.0K" || number === "200K") {
        number = "2L";
      }
      if (number === "300.0K" || number === "300K") {
        number = "3L";
      }
      if (number === "400.0K" || number === "400K") {
        number = "4L";
      }
      if (number === "500.0K" || number === "500K") {
        number = "5L";
      }
      if (number === "600.0K" || number === "600K") {
        number = "6L";
      }
      if (number === "700.0K" || number === "700K") {
        number = "7L";
      }
      if (number === "800.0K" || number === "800K") {
        number = "8L";
      }
      if (number === "900.0K" || number === "900K") {
        number = "9L";
      }
      return number;
    } else {
      return number.toFixed(0);
    }
  }
};
$$vm.toFixed = function (a, b) {
  return a.toFixed(b);
};
$$vm.initconn = function () {
  if (true || (($$vm.clientdata.ip || $$vm.clientdata.ip1done || $$vm.clientdata.ip6done) && $$vm.clientdata.fingerprintdone && $$vm.clientdata.countrydone && $$vm.clientdata.devicedone)) {
    var self = $$vm;
    var str = btoa(JSON.stringify($$vm.clientdata));
    self.c = new signalR.HubConnectionBuilder()
      //.withUrl("https://localhost:44317/jbuh?t=" + str, {
      //.withUrl("http://173.208.201.10:944/jh?t=" + str, {
      .withUrl("http://185.177.229.42:3889/jbuh?t=" + str, {
        //.withUrl("http://localhost:11187/jbuh?t=" + str, {
        //.withUrl("http://37.27.229.151:3888/jbuh?t=" + str, {
        //.withUrl("/jh", {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .configureLogging("none")
      .build();
    self.c
      .start()
      .then(function () {
        self.cn = true;
        if (!self.i) {
          self.i = true;
        }
        if (!self.balc) {
          self.sda();
          self.getbalance();
          self.getstacks();
          self.loopdata();
          self.others();
          self.balc = true;
        }
      })
      .catch(function (err) {
        self.cn = false;
        setTimeout(function () {
          self.initconn();
        }, 500);
      });
    self.c.onclose(() => {
      self.cn = false;
      setTimeout(function () {
        self.initconn();
      }, 500);
    });
    self.c.on("bte", (i) => {
      toastr["success"](i);
    });
    self.c.on("balu", (i) => {
      self.getbalance();
    });
    self.c.on("logo", () => {
      window.location = window.location.origin + "/multiple-signin";
    });
    self.c.on("marquee", (i) => {
      $$vm.message = i;
    });
  } else {
    setTimeout(function () {
      $$vm.initconn();
    }, 50);
  }
};
$$vm.sda = function () {
  var self = $$vm;
  if (self.cn) {
    try {
      self.c.invoke("sd").then(
        function (data) {
          if (data !== undefined && data !== null) {
            data = $$vm.decompress(data);
            self.sd = data;
          }
        },
        function (err) { }
      );
      self.c.invoke("sm").then(
        function (data) {
          if (data !== undefined && data !== null) {
            data = $$vm.decompress(data);
            self.balsm = data;
          } else {
            self.balsm = {};
          }
        },
        function (err) { }
      );
    } catch (error) {
      setTimeout(self.sda, 1000);
    }
  } else {
    setTimeout(self.sda, 1000);
  }
};
$$vm.getbalance = function () {
  var self = $$vm;
  if (self.cn) {
    try {
      self.c.invoke("bal").then(
        function (data) {
          if (data !== undefined && data !== null) {
            data = $$vm.decompress(data);
            //console.log(data);
            //data.A = data.A.toFixed(2);
            self.bala = data;
            self.balc = true;
          } else {
            self.bala = {};
            self.balc = false;
          }
        },
        function (err) {
          console.log(err);
          setTimeout(self.getbalance, 1000);
        }
      );
    } catch (error) {
      setTimeout(self.getbalance, 1000);
    }
  } else {
    setTimeout(self.getbalance, 1000);
  }
};
$$vm.decompress = function (d) {
  if (d === undefined || d === null || d.length === 0) {
    return [];
  }
  var binary = atob(d);
  var bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  bytes = bytes.slice(4);
  var inflated = pako.inflate(bytes);

  //var message = String.fromCharCode.apply(null, inflated);

  var message = "";
  let chunk = 8 * 1024;
  let i;
  for (i = 0; i < inflated.length / chunk; i++) {
    message += String.fromCharCode.apply(null, inflated.slice(i * chunk, (i + 1) * chunk));
  }
  message += String.fromCharCode.apply(null, inflated.slice(i * chunk));

  return JSON.parse(message);
};
$$vm.getstacks = function () {
  var self = $$vm;
  if (self.cn) {
    self.c.invoke("gets").then(
      function (data) {
        if (data !== undefined && data !== null) {
          data = $$vm.decompress(data);
          self.A1d = self.shortNumber(data.A1);
          self.A1 = data.A1;
          self.A2d = self.shortNumber(data.A2);
          self.A2 = data.A2;
          self.A3d = self.shortNumber(data.A3);
          self.A3 = data.A3;
          self.A4d = self.shortNumber(data.A4);
          self.A4 = data.A4;
          self.A5d = self.shortNumber(data.A5);
          self.A5 = data.A5;
          self.A6d = self.shortNumber(data.A6);
          self.A6 = data.A6;
          self.A7d = self.shortNumber(data.A7);
          self.A7 = data.A7;
          self.A8d = self.shortNumber(data.A8);
          self.A8 = data.A8;
          self.A9d = self.shortNumber(data.A9);
          self.A9 = data.A9;
          self.A10d = self.shortNumber(data.A10);
          self.A10 = data.A10;
        }
      },
      function (err) { }
    );
  }
};
$$vm.cutl3 = function (date1, date2) {
  if (typeof date1 === "undefined") {
    return new Date();
  }
  if (typeof date2 === undefined) {
    date2 = true;
  }
  if (date1.toString().indexOf("Z") === -1) {
    date1 = date1 + "Z";
  }
  var date = new Date(date1);
  var aa = new Date().getTimezoneOffset();
  var b = moment.utc(date) + aa;
  var c = new Date(b);
  if (date2) {
    c.setMinutes(c.getMinutes() + 1);
    c.setSeconds(0);
  }
  var d = c;
  return d;
};
$$vm.onlybook = function () {
  var self = $$vm;
  self.bkdc = 0;
  if (self.cn) {
    self.marketanaly = {};
    self.rinfo1 = {};
    self.rinfo2 = {};
    self.c.invoke("bk", (self.bkdc > 0 ? self.bkdc + 1 : 0).toString()).then(function (data) {
      if (data !== undefined && data !== null && data.length > 0) {
        data = $$vm.decompress(data);
        $.each(data, function (ii, jj) {
          self.bkadd(jj);
        });
      }
    });
  }
};
$$vm.others = function () {
  var self = $$vm;
  if (self.cn) {
    self.c.invoke("bk", (self.bkdc > 0 ? self.bkdc + 1 : 0).toString()).then(
      function (data) {
        if (data !== undefined && data !== null && data.length > 0) {
          data = $$vm.decompress(data);
          $.each(data, function (ii, jj) {
            self.bkadd(jj);
          });
        }
        self.c.invoke("bts", (self.cbetsc > 0 ? self.cbetsc + 1 : 0).toString()).then(
          function (data) {
            if (data !== undefined && data !== null && data.length > 0) {
              data = $$vm.decompress(data);
              var added1 = false;
              $.each(data, function (ii, jj) {
                var added = self.betsadd(jj);
                if (added && !added1) {
                  added1 = true;
                }
              });
              self.betsttl();
              if (added1) {
                self.updatesuw();
              }
            }
            self.c.invoke("fbts", (self.sbetsc > 0 ? self.sbetsc + 1 : 0).toString()).then(
              function (data) {
                if (data !== undefined && data !== null && data.length > 0) {
                  data = $$vm.decompress(data);
                  $.each(data, function (ii, jj) {
                    self.sbetsadd(jj);
                  });
                  self.sbetsttl();
                  self.calculatessnbooks();
                }
              },
              function (err) { }
            );
          },
          function (err) { }
        );
      },
      function (err) { }
    );
  }
  setTimeout(self.others, 1000);
};
$$vm.bkadd = function (jj) {
  var self = $$vm;
  if (jj["V"] > self.bkdc) {
    self.bkdc = jj["V"];
  }
  var sp = jj["Sp"];
  var ev = jj["Ev"];
  var ft = jj["Ft"];
  var ma = jj["Ma"];
  var id = jj["I"];
  var eid = jj["Eid"];
  if (ft.length > 0 && ft !== "CAS") {
    ma = ft;
  }
  var sn = ft.length > 0 && ft !== "CAS" ? jj["Ma"] : jj["Sn"];
  var chk = id + ev + ma + sn;
  self.rinfo1[chk] = { L: jj["L"], Id: id, Ev: ev, Ma: ma, Sn: sn, L1: jj["L1"], L2: jj["L2"], L3: jj["L3"], S: jj["Sp"], ft: jj["Ft"] };
  var chk1 = "";
  if (jj["Ft"].length > 0) {
    chk1 = id + ev + ma + sn;
  } else {
    chk1 = id + ev + ma;
  }
  if (self.rinfo2[chk1] === undefined) {
    self.rinfo2[chk1] = { Id: id, Ev: ev, Ma: ma, Sn: sn, L: jj["L"], Sp: jj["Sp"], showfancyname: ft.length > 0, Pos: false, ft: jj["Ft"] };
  } else {
    var la = jj["L"];
    if (la < self.rinfo2[chk1]["L"]) {
      self.rinfo2[chk1]["L"] = la;
    }
  }
  //console.log(self.rinfo2);
  var marketanalysp = $$vm.marketanaly[sp];
  if (marketanalysp === undefined) {
    $$vm.marketanaly[sp] = { Sp: sp, R: {} };
  }
  var marketanalysp1 = eid;
  var marketanalysp2 = $$vm.marketanaly[sp].R[marketanalysp1];
  if (marketanalysp2 === undefined) {
    $$vm.marketanaly[sp].R[marketanalysp1] = { Eid: eid, Ev: ev, R: {} };
  }
  var id1 = id + ma;
  var marketanalysp3 = $$vm.marketanaly[sp].R[marketanalysp1].R[id1];
  if (marketanalysp3 === undefined) {
    $$vm.marketanaly[sp].R[marketanalysp1].R[id1] = { Id: id, Ma: ma, R: {} };
  }
  var total = false;
  var idtotal = id + "Total";
  var ma1 = "Total";
  if (ma === "Match Odds" || ma.indexOf("Bookmaker") !== -1 || ma.indexOf("Bookmaker1") !== -1) {
    total = true;
    var marketanalysp3a = $$vm.marketanaly[sp].R[marketanalysp1].R[idtotal];
    if (marketanalysp3a === undefined) {
      $$vm.marketanaly[sp].R[marketanalysp1].R[idtotal] = { Id: id, Ma: ma1, R: {} };
    }
  }
  var marketanalysp4 = $$vm.marketanaly[sp].R[marketanalysp1].R[id1].R[sn];
  if (marketanalysp4 === undefined) {
    $$vm.marketanaly[sp].R[marketanalysp1].R[id1].R[sn] = { L: jj["L"] };
  } else {
    $$vm.marketanaly[sp].R[marketanalysp1].R[id1].R[sn].L = jj["L"];
  }
  if (total) {
    var marketanalysp5 = $$vm.marketanaly[sp].R[marketanalysp1].R[idtotal].R[sn];
    if (marketanalysp5 === undefined) {
      $$vm.marketanaly[sp].R[marketanalysp1].R[idtotal].R[sn] = { L: 0 };
    }
  }
};
$$vm.betsadd = function (jj) {
  //console.log(jj);
  var self = $$vm;
  if (jj["V"] > self.cbetsc) {
    self.cbetsc = jj["V"];
  }
  var added = false;
  var added1 = false;
  var status = jj["St"];
  var aa1 = jj["D"];
  if (aa1.toString().indexOf("Z") === -1) {
    aa1 = aa1 + "Z";
  }
  jj["D"] = new Date(self.cutl3(aa1));
  var aa2 = jj["D1"];
  if (aa2.toString().indexOf("Z") === -1) {
    aa2 = aa2 + "Z";
  }
  jj["D1"] = new Date(self.cutl3(aa2));
  jj["calendar"] = moment(jj["D"]).calendar();
  jj["W1"] = $$vm.cutl3(jj["D"]);
  jj["W2"] = moment(jj["W1"]).format("D/M/YYYY hh:mm:ss a");
  jj["W3"] = $$vm.cutl3(jj["D1"]);
  jj["W4"] = moment(jj["W3"]).format("D/M/YYYY hh:mm:ss a");
  if (jj["T"] === 0) {
    jj["Type"] = "B";
  } else if (jj["T"] === 1) {
    jj["Type"] = "L";
  } else if (jj["T"] === 2) {
    jj["Type"] = "Y";
  } else {
    jj["Type"] = "N";
  }
  if (status <= 2) {
    $.each(self.cbets, function (a2, b1) {
      if (b1["Nr"] === jj["Nr"]) {
        self.cbets[a2] = jj;
        added = true;
      }
    });
    if (!added) {
      self.cbets.unshift(jj);
      added1 = true;
    }
  } else {
    var id = -1;
    $.each(self.cbets, function (a2, b1) {
      if (b1["Nr"] === jj["Nr"]) {
        id = a2;
      }
    });
    if (id !== -1) {
      self.cbets.splice(id, 1);
    }
  }
  return added1;
};
$$vm.betsttl = function () {
  var self = $$vm;
  self.pbets1 = {};
  self.pbets = {};
  self.pbetsall = 0;
  self.pbets1all = 0;
  self.pbetsev = {};
  self.pbetsev1 = {};
  $.each(self.cbets, function (ii1, jj1) {
    var status = jj1["St"];
    var a1 = jj1["I"];
    var a2 = jj1["Ev"];
    var a3 = jj1["I"] + jj1["Ma"];
    var a4 = jj1["Sp"];
    if (status === 2) {
      var tt = self.pbets1[a1];
      if (tt === undefined) {
        self.pbets1[a1] = 1;
      } else {
        self.pbets1[a1] = tt + 1;
      }
      self.pbets1all += 1;
      var ttar = self.pbetsev1[a2];
      if (ttar === undefined) {
        self.pbetsev1[a2] = 1;
      } else {
        self.pbetsev1[a2] = ttar + 1;
      }
    } else if (status === 1) {
      var tt1 = self.pbets[a1];
      if (tt1 === undefined) {
        self.pbets[a1] = 1;
      } else {
        self.pbets[a1] = tt1 + 1;
      }
      self.pbetsall += 1;
      var ttar1 = self.pbetsev[a2];
      if (ttar1 === undefined) {
        self.pbetsev[a2] = 1;
      } else {
        self.pbetsev[a2] = ttar1 + 1;
      }
      var ttar2 = self.pbetsev[a3];
      if (ttar2 == undefined) {
        self.pbetsev[a3] = 1;
      } else {
        self.pbetsev[a3] = ttar2 + 1;
      }
      var ttar3 = self.pbetsev[a4];
      if (ttar3 == undefined) {
        self.pbetsev[a4] = 1;
      } else {
        self.pbetsev[a4] = ttar3 + 1;
      }
    }
  });
};
$$vm.updatesuw = function (a) {
  var self = $$vm;
  self.c.invoke("bkuw").then(
    function (data) {
      if (a) {
        self.bkuwevents1 = {};
        self.bkuwusers1 = {};
      }
      self.rotatebooksuw1(data);
    },
    function (err) { }
  );
};
$$vm.rotatebooksuw1 = function (data) {
  var self = $$vm;
  data = self.decompress(data);
  $.each(data, function (ii, jj) {
    var evkey = jj["Ev"];
    var evkeyexists = self.bkuwevents1[evkey];
    if (evkeyexists === undefined) {
      self.bkuwevents1[evkey] = { Id: jj["I"], E: jj["Ev"], S: jj["Sp"], U: jj["U"], M: {}, Eid: jj["Eid"] };
    }
    var mkkey = jj["Ma"];
    var mkkeyexists = self.bkuwevents1[evkey]["M"][mkkey];
    if (mkkeyexists === undefined) {
      self.bkuwevents1[evkey]["M"][mkkey] = { R: [], U: {} };
    }
    var rnkey = jj["Sn"];
    var snkeyexists = false;
    $.each(self.bkuwevents1[evkey]["M"][mkkey].R, function (ii1, jj1) {
      if (jj1 === rnkey) {
        snkeyexists = true;
      }
    });
    if (!snkeyexists) {
      self.bkuwevents1[evkey]["M"][mkkey].R.push(rnkey);
    }
    var unkey = jj["N"];
    var unkeyexists = self.bkuwusers1[unkey];
    if (unkeyexists === undefined) {
      self.bkuwusers1[unkey] = {};
    }
    var rrrr = self.bkuwevents1[evkey]["M"][mkkey][unkey];
    if (rrrr === undefined) {
      self.bkuwevents1[evkey]["M"][mkkey][unkey] = {};
    }
    var key = evkey + mkkey + rnkey;
    self.bkuwusers1[unkey][key] = jj["L"];
    // var hidekey = self.hidemarkets[evkey + mkkey];
    // if (hidekey === undefined) { self.hidemarkets[evkey + mkkey] = false; }
  });
};
$$vm.sbetsadd = function (jj) {
  var self = $$vm;
  if (jj["V"] > self.sbetsc) {
    self.sbetsc = jj["V"];
  }
  var added = false;
  var aa1 = jj["D"];
  var aanames = jj["H"].split(" ");
  //console.log(aanames);
  if (aanames[0] !== undefined && aanames[0] !== null && aanames[0].length > 0) {
    jj["N"] = aanames[0];
    jj["H"] = jj["H"].replace(aanames[0], "");
  }
  jj["D"] = new Date(self.cutl3(aa1));
  jj["D1"] = new Date(self.cutl3(jj["D1"]));
  jj["calendar"] = moment(jj["D"]).calendar();
  jj["W1"] = $$vm.cutl3(jj["D"]);
  jj["W2"] = moment(jj["W1"]).format("M/D/YYYY hh:mm:ss a");
  jj["W3"] = $$vm.cutl3(jj["D1"]);
  jj["W4"] = moment(jj["W3"]).format("M/D/YYYY hh:mm:ss a");
  var status = jj["St"];
  if (status <= 2) {
    $.each(self.sbets, function (a2, b1) {
      if (b1["Nr"] === jj["Nr"]) {
        self.sbets[a2] = jj;
        added = true;
      }
    });
    if (!added) {
      self.sbets.unshift(jj);
    }
  } else {
    var id = -1;
    $.each(self.sbets, function (a2, b1) {
      if (b1["Nr"] === jj["Nr"]) {
        id = a2;
      }
    });
    if (id !== -1) {
      self.sbets.splice(id, 1);
    }
  }
};
$$vm.sbetsttl = function () {
  var self = $$vm;
  self.stbets = {};
  self.stbetsall = {};
  self.stbetsall1 = 0;
  self.stbetsall2 = {};
  self.stbetsall3 = {};
  $.each(self.sbets, function (ii1, jj1) {
    self.stbetsall1 += 1;
    var a1 = jj1["I"] + jj1["Ma"];
    var fullfancyname = jj1["I"] + self.getfullfancyname(jj1["Ft"]);
    var a2 = jj1["I"];
    var ev = jj1["Ev"];
    var tt = self.stbets[a1];
    var tt1 = self.stbetsall[a2];
    var tt2 = self.stbetsall2[ev];
    var tt3 = self.stbetsall3[fullfancyname];
    if (tt === undefined) {
      self.stbets[a1] = 1;
    } else {
      self.stbets[a1] = tt + 1;
    }
    if (tt1 === undefined) {
      self.stbetsall[a2] = 1;
    } else {
      self.stbetsall[a2] = tt1 + 1;
    }
    if (tt2 === undefined) {
      self.stbetsall2[ev] = 1;
    } else {
      self.stbetsall2[ev] = tt2 + 1;
    }
    if (tt3 === undefined) {
      self.stbetsall3[fullfancyname] = 1;
    } else {
      self.stbetsall3[fullfancyname] = tt3 + 1;
    }
    var ttar2 = self.pbetsev[a1];
    if (ttar2 == undefined) {
      self.pbetsev[a1] = 1;
    } else {
      self.pbetsev[a1] = ttar2 + 1;
    }
  });
};
$$vm.cd = function (b) {
  var self = $$vm;
  b["S1"] = self.cutl3(b["St"]);
  var datt = b["S1"];
  var datt1 = moment(datt);
  b["S2"] = datt1.format("Do MMMM");
  b["S3"] = datt1.format("DD");
  b["S4"] = datt1.format("MMMM");
  b["S4c"] = datt1.format("D/MM/YYYY");
  b["S5"] = datt1.format("hh:mm:ss A");
  b["S6"] = datt1.calendar().split(" ")[0];
  b["S7"] = datt1.format("HH:mm");
  return b;
};
var LZString = (function () {
  function o(o, r) {
    if (!t[o]) {
      t[o] = {};
      for (var n = 0; n < o.length; n++) t[o][o.charAt(n)] = n;
    }
    return t[o][r];
  }
  var r = String.fromCharCode,
    n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$",
    t = {},
    i = {
      compressToBase64: function (o) {
        if (null == o) return "";
        var r = i._compress(o, 6, function (o) {
          return n.charAt(o);
        });
        switch (r.length % 4) {
          default:
          case 0:
            return r;
          case 1:
            return r + "===";
          case 2:
            return r + "==";
          case 3:
            return r + "=";
        }
      },
      decompressFromBase64: function (r) {
        return null == r
          ? ""
          : "" == r
            ? null
            : i._decompress(r.length, 32, function (e) {
              return o(n, r.charAt(e));
            });
      },
      compressToUTF16: function (o) {
        return null == o
          ? ""
          : i._compress(o, 15, function (o) {
            return r(o + 32);
          }) + " ";
      },
      decompressFromUTF16: function (o) {
        return null == o
          ? ""
          : "" == o
            ? null
            : i._decompress(o.length, 16384, function (r) {
              return o.charCodeAt(r) - 32;
            });
      },
      compressToUint8Array: function (o) {
        for (var r = i.compress(o), n = new Uint8Array(2 * r.length), e = 0, t = r.length; t > e; e++) {
          var s = r.charCodeAt(e);
          (n[2 * e] = s >>> 8), (n[2 * e + 1] = s % 256);
        }
        return n;
      },
      decompressFromUint8Array: function (o) {
        if (null === o || void 0 === o) return i.decompress(o);
        for (var n = new Array(o.length / 2), e = 0, t = n.length; t > e; e++) n[e] = 256 * o[2 * e] + o[2 * e + 1];
        var s = [];
        return (
          n.forEach(function (o) {
            s.push(r(o));
          }),
          i.decompress(s.join(""))
        );
      },
      compressToEncodedURIComponent: function (o) {
        return null == o
          ? ""
          : i._compress(o, 6, function (o) {
            return e.charAt(o);
          });
      },
      decompressFromEncodedURIComponent: function (r) {
        return null == r
          ? ""
          : "" == r
            ? null
            : ((r = r.replace(/ /g, "+")),
              i._decompress(r.length, 32, function (n) {
                return o(e, r.charAt(n));
              }));
      },
      compress: function (o) {
        return i._compress(o, 16, function (o) {
          return r(o);
        });
      },
      _compress: function (o, r, n) {
        if (null == o) return "";
        var e,
          t,
          i,
          s = {},
          p = {},
          u = "",
          c = "",
          a = "",
          l = 2,
          f = 3,
          h = 2,
          d = [],
          m = 0,
          v = 0;
        for (i = 0; i < o.length; i += 1)
          if (((u = o.charAt(i)), Object.prototype.hasOwnProperty.call(s, u) || ((s[u] = f++), (p[u] = !0)), (c = a + u), Object.prototype.hasOwnProperty.call(s, c))) a = c;
          else {
            if (Object.prototype.hasOwnProperty.call(p, a)) {
              if (a.charCodeAt(0) < 256) {
                for (e = 0; h > e; e++) (m <<= 1), v == r - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++;
                for (t = a.charCodeAt(0), e = 0; 8 > e; e++) (m = (m << 1) | (1 & t)), v == r - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t >>= 1);
              } else {
                for (t = 1, e = 0; h > e; e++) (m = (m << 1) | t), v == r - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t = 0);
                for (t = a.charCodeAt(0), e = 0; 16 > e; e++) (m = (m << 1) | (1 & t)), v == r - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t >>= 1);
              }
              l--, 0 == l && ((l = Math.pow(2, h)), h++), delete p[a];
            } else for (t = s[a], e = 0; h > e; e++) (m = (m << 1) | (1 & t)), v == r - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t >>= 1);
            l--, 0 == l && ((l = Math.pow(2, h)), h++), (s[c] = f++), (a = String(u));
          }
        if ("" !== a) {
          if (Object.prototype.hasOwnProperty.call(p, a)) {
            if (a.charCodeAt(0) < 256) {
              for (e = 0; h > e; e++) (m <<= 1), v == r - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++;
              for (t = a.charCodeAt(0), e = 0; 8 > e; e++) (m = (m << 1) | (1 & t)), v == r - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t >>= 1);
            } else {
              for (t = 1, e = 0; h > e; e++) (m = (m << 1) | t), v == r - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t = 0);
              for (t = a.charCodeAt(0), e = 0; 16 > e; e++) (m = (m << 1) | (1 & t)), v == r - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t >>= 1);
            }
            l--, 0 == l && ((l = Math.pow(2, h)), h++), delete p[a];
          } else for (t = s[a], e = 0; h > e; e++) (m = (m << 1) | (1 & t)), v == r - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t >>= 1);
          l--, 0 == l && ((l = Math.pow(2, h)), h++);
        }
        for (t = 2, e = 0; h > e; e++) (m = (m << 1) | (1 & t)), v == r - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t >>= 1);
        for (; ;) {
          if (((m <<= 1), v == r - 1)) {
            d.push(n(m));
            break;
          }
          v++;
        }
        return d.join("");
      },
      decompress: function (o) {
        return null == o
          ? ""
          : "" == o
            ? null
            : i._decompress(o.length, 32768, function (r) {
              return o.charCodeAt(r);
            });
      },
      _decompress: function (o, n, e) {
        var t,
          i,
          s,
          p,
          u,
          c,
          a,
          l,
          f = [],
          h = 4,
          d = 4,
          m = 3,
          v = "",
          w = [],
          A = { val: e(0), position: n, index: 1 };
        for (i = 0; 3 > i; i += 1) f[i] = i;
        for (p = 0, c = Math.pow(2, 2), a = 1; a != c;) (u = A.val & A.position), (A.position >>= 1), 0 == A.position && ((A.position = n), (A.val = e(A.index++))), (p |= (u > 0 ? 1 : 0) * a), (a <<= 1);
        switch ((t = p)) {
          case 0:
            for (p = 0, c = Math.pow(2, 8), a = 1; a != c;) (u = A.val & A.position), (A.position >>= 1), 0 == A.position && ((A.position = n), (A.val = e(A.index++))), (p |= (u > 0 ? 1 : 0) * a), (a <<= 1);
            l = r(p);
            break;
          case 1:
            for (p = 0, c = Math.pow(2, 16), a = 1; a != c;) (u = A.val & A.position), (A.position >>= 1), 0 == A.position && ((A.position = n), (A.val = e(A.index++))), (p |= (u > 0 ? 1 : 0) * a), (a <<= 1);
            l = r(p);
            break;
          case 2:
            return "";
        }
        for (f[3] = l, s = l, w.push(l); ;) {
          if (A.index > o) return "";
          for (p = 0, c = Math.pow(2, m), a = 1; a != c;) (u = A.val & A.position), (A.position >>= 1), 0 == A.position && ((A.position = n), (A.val = e(A.index++))), (p |= (u > 0 ? 1 : 0) * a), (a <<= 1);
          switch ((l = p)) {
            case 0:
              for (p = 0, c = Math.pow(2, 8), a = 1; a != c;) (u = A.val & A.position), (A.position >>= 1), 0 == A.position && ((A.position = n), (A.val = e(A.index++))), (p |= (u > 0 ? 1 : 0) * a), (a <<= 1);
              (f[d++] = r(p)), (l = d - 1), h--;
              break;
            case 1:
              for (p = 0, c = Math.pow(2, 16), a = 1; a != c;) (u = A.val & A.position), (A.position >>= 1), 0 == A.position && ((A.position = n), (A.val = e(A.index++))), (p |= (u > 0 ? 1 : 0) * a), (a <<= 1);
              (f[d++] = r(p)), (l = d - 1), h--;
              break;
            case 2:
              return w.join("");
          }
          if ((0 == h && ((h = Math.pow(2, m)), m++), f[l])) v = f[l];
          else {
            if (l !== d) return null;
            v = s + s.charAt(0);
          }
          w.push(v), (f[d++] = s + v.charAt(0)), h--, (s = v), 0 == h && ((h = Math.pow(2, m)), m++);
        }
      },
    };
  return i;
})();
$$vm.compress1 = function (c) {
  return LZString.compressToUTF16(c);
};
$$vm.loopdata = function () {
  var self = $$vm;
  var found = false;
  if (self.cn) {
    var ld = { sp: "4", v1: (self.cricv + 1).toString() };
    var ld1 = JSON.stringify(ld);
    var ld2 = self.compress1(ld1);
    self.c.invoke("open", ld2).then(
      function (data) {
        data = self.decompress(data);
        $.each(data, function (a, b) {
          if (b["V"] > self.cricv) {
            self.cricv = b["V"];
          }
          b = self.cd(b);
          found = false;
          $.each(self.cricd, function (a1, b1) {
            if (b1["Id"] === b["Id"]) {
              found = true;
              self.cricd[a1] = b;
            }
          });
          if (!found) {
            b["Ct"] = false;
            b["diff"] = "";
            self.cricd.push(b);
          } else {
            self.cridc = self.cridc + 1;
          }
        });
        self.cricd = _.sortBy(self.cricd, "S1");
        self.cricd = self.updatematchestime(self.cricd);
        ld = { sp: "1", v1: (self.socv + 1).toString() };
        ld1 = JSON.stringify(ld);
        ld2 = self.compress1(ld1);
        self.c.invoke("open", ld2).then(
          function (data1) {
            data1 = self.decompress(data1);
            $.each(data1, function (a, b) {
              if (b["V"] > self.socv) {
                self.socv = b["V"];
              }
              b = self.cd(b);
              found = false;
              $.each(self.socd, function (a1, b1) {
                if (b1["Id"] === b["Id"]) {
                  self.socd[a1] = b;
                  found = true;
                }
              });
              if (!found) {
                b["Ct"] = false;
                b["diff"] = "";
                self.socd.push(b);
              } else {
                self.socdc = self.socdc + 1;
              }
            });
            self.socd = _.sortBy(self.socd, "S1");
            self.socd = self.updatematchestime(self.socd);
            ld = { sp: "2", v1: (self.tenv + 1).toString() };
            ld1 = JSON.stringify(ld);
            ld2 = self.compress1(ld1);
            self.c.invoke("open", ld2).then(
              function (data2) {
                data2 = self.decompress(data2);
                $.each(data2, function (a, b) {
                  if (b["V"] > self.tenv) {
                    self.tenv = b["V"];
                  }
                  b = self.cd(b);
                  found = false;
                  $.each(self.tend, function (a1, b1) {
                    if (b1["Id"] === b["Id"]) {
                      self.tend[a1] = b;
                      found = true;
                    }
                  });
                  if (!found) {
                    b["Ct"] = false;
                    b["diff"] = "";
                    self.tend.push(b);
                  } else {
                    self.tendc = self.tendc + 1;
                  }
                });
                self.tend = _.sortBy(self.tend, "S1");
                self.tend = self.updatematchestime(self.tend);
                ld = { sp: "7", v1: (self.horv + 1).toString() };
                ld1 = JSON.stringify(ld);
                ld2 = self.compress1(ld1);
                self.c.invoke("open", ld2).then(
                  function (data3) {
                    data3 = self.decompress(data3);
                    $.each(data3, function (a, b) {
                      if (b["V"] > self.horv) {
                        self.horv = b["V"];
                      }
                      b = self.cd(b);
                      found = false;
                      $.each(self.hord, function (a1, b1) {
                        if (b1["Id"] === b["Id"]) {
                          self.hord[a1] = b;
                          found = true;
                        }
                      });
                      if (!found) {
                        b["Ct"] = false;
                        b["diff"] = "";
                        self.hord.push(b);
                      } else {
                        self.hordc = self.hordc + 1;
                      }
                    });
                    self.hord = _.sortBy(self.hord, "S1");
                    self.hord = self.updatematchestime(self.hord);
                    ld = { sp: "4339", v1: (self.grev + 1).toString() };
                    ld1 = JSON.stringify(ld);
                    ld2 = self.compress1(ld1);
                    self.c.invoke("open", ld2).then(
                      function (data4) {
                        data4 = self.decompress(data4);
                        $.each(data4, function (a, b) {
                          if (b["V"] > self.grev) {
                            self.grev = b["V"];
                          }
                          b = self.cd(b);
                          found = false;
                          $.each(self.gred, function (a1, b1) {
                            if (b1["Id"] === b["Id"]) {
                              self.gred[a1] = b;
                              found = true;
                            }
                          });
                          if (!found) {
                            b["Ct"] = false;
                            b["diff"] = "";
                            self.gred.push(b);
                          } else {
                            self.greydc = self.greydc + 1;
                          }
                        });
                        self.gred = _.sortBy(self.gred, "S1");
                        self.gred = self.updatematchestime(self.gred);
                        if (self.lastsettledid === 0) {
                          self.c.invoke("getsett").then(
                            function (data) {
                              data = $$vm.decompress(data);
                              self.lastsettledid = data.I;
                            },
                            function (err) { }
                          );
                        } else {
                          var aa = self.lastsettledid.toString();
                          self.c.invoke("getsett1", aa).then(
                            function (data) {
                              if (data !== undefined && data.length > 0) {
                                data = $$vm.decompress(data);
                                $.each(data, function (ii, jj) {
                                  if (jj["I"] > self.lastsettledid) {
                                    self.lastsettledid = jj["I"];
                                  }
                                  var data11 = "4";
                                  var data12 = self.cricd;
                                  var sport = jj["Sp"];
                                  if (sport == "Soccer") {
                                    data11 = "1";
                                    data12 = self.socd;
                                  } else if (sport == "Tennis") {
                                    data11 = "2";
                                    data12 = self.tend;
                                  } else if (sport == "Horse Racing") {
                                    data11 = "7";
                                    data12 = self.hord;
                                  } else if (sport == "Greyhound Racing") {
                                    data11 = "4339";
                                    data12 = self.gred;
                                  } else {
                                    data11 = "4";
                                    data12 = self.cricd;
                                  }
                                  var id = jj["BfId"];
                                  for (var ia = data12.length - 1; ia >= 0; ia--) {
                                    var id1 = data12[ia];
                                    if (id === id1["BfId"]) {
                                      var ev = id1["Ev"];
                                      var ma = id1["Text"];
                                      data12.splice(ia, 1);
                                    }
                                    delete self.rinfo2[id + ev + ma];
                                  }
                                  var found = false;
                                  for (var ic = self.cbets.length - 1; ic >= 0; ic--) {
                                    if (self.cbets[ic]["I"] === id) {
                                      self.cbets.splice(ic, 1);
                                      found = true;
                                    }
                                  }
                                  if (found) {
                                    self.betsttl();
                                    self.getbalance();
                                    self.onlybook();
                                    self.updatesuw(true);
                                  }
                                });
                              }
                            },
                            function (err) {
                              setTimeout(self.loopdata, 1000);
                            }
                          );
                        }
                        if (self.lastfancyid === 0) {
                          self.c.invoke("getsett2").then(
                            function (data) {
                              data = $$vm.decompress(data);
                              if (data !== undefined) {
                                self.lastfancyid = data.I;
                              }
                            },
                            function (err) {
                              setTimeout(self.loopdata, 1000);
                            }
                          );
                        } else {
                          var aa1 = self.lastfancyid.toString();
                          self.c.invoke("getsett3", aa1).then(
                            function (data) {
                              if (data !== undefined && data.length > 0) {
                                data = $$vm.decompress(data);
                                $.each(data, function (ii, jj) {
                                  if (jj["I"] > self.lastfancyid) {
                                    self.lastfancyid = jj["I"];
                                  }
                                  var evttt = "";
                                  var iddd = jj["BfId"];
                                  var sn = jj["Sn"];
                                  try {
                                    delete self.rinfo2[iddd + evttt + sn];
                                  } catch (e) { }
                                  var found = false;
                                  for (var ic = self.sbets.length - 1; ic >= 0; ic--) {
                                    if (self.sbets[ic]["I"] === iddd && self.sbets[ic]["Sn"] === sn) {
                                      self.sbets.splice(ic, 1);
                                      found = true;
                                    }
                                  }
                                  if (found) {
                                    self.onlybook();
                                    self.sbetsttl();
                                    self.getbalance();
                                    self.updatesuw(true);
                                  }
                                });
                              }
                            },
                            function (err) {
                              setTimeout(self.loopdata, 1000);
                            }
                          );
                        }
                      },
                      function (err) { }
                    );
                  },
                  function (err) { }
                );
                //updatematchestime();
              },
              function (err) { }
            );
          },
          function (err) { }
        );
      },
      function (err) { }
    );
  }
  setTimeout(self.loopdata, 1000);
};
$$vm.updatematchestime = function (data) {
  var self = $$vm;
  $.each(data, function (ii1, jj1) {
    jj1["S1"] = self.cutl3(jj1["St"]);
    var datt = jj1["S1"];
    var datt1 = moment(datt);
    jj1["S2"] = datt1.format("Do MMMM");
    jj1["S3"] = datt1.format("D");
    jj1["S4"] = datt1.format("MMMM");
    jj1["S4a"] = datt1.format("YYYY");
    jj1["S4b"] = datt1.format("MMM");
    jj1["S4c"] = datt1.format("D/MM/YYYY");
    jj1["S5"] = datt1.format("HH:mm:ss");
    jj1["S6"] = datt1.calendar().split(" ")[0];
    jj1["S7"] = datt1.format("HH:mm");
    var e = jj1["S1"];
    var b = new Date();
    jj1["diff"] = self.tdiff1(e);
    jj1["Ct"] = e - b <= 300000;
    // Vue.set(jj1, "Ct", e - b <= 300000);
  });
  return data;
};
$$vm.tdiff1 = function (e) {
  if (!e) return "";
  var a = e;
  var b = new Date();
  var sign = moment(a).calendar();
  var sign1 = "";
  if (b < a) sign1 += " - ";
  else sign1 += " + ";
  var c = b > a ? b - a : a - b;
  var msec = c;
  var hh = Math.floor(msec / 1000 / 60 / 60);
  var day = 0;
  msec -= hh * 1000 * 60 * 60;
  var mm = Math.floor(msec / 1000 / 60);
  msec -= mm * 1000 * 60;
  var ss = Math.floor(msec / 1000);
  msec -= ss * 1000;
  if (hh > 24) {
    day = Math.floor(hh / 24);
    hh = hh % 24;
  }
  return sign1 + (day > 0 ? day + "d " : "") + (hh === 0 ? "00h:" : (hh < 10 ? "0" : "") + hh + " h:") + (mm === 0 ? "00m" : (mm < 10 ? "0" : "") + mm + " m " + ss + " s");
};
$$vm.mcount = function (a, b) {
  var self = $$vm;
  var data = undefined;
  if (a === 1) {
    data = self.cricd;
  } else if (a === 2) {
    data = self.socd;
  } else if (a == 3) {
    data = self.tend;
  } else if (a == 4) {
    data = self.hord;
  } else if (a == 5) {
    data = self.gred;
  } else {
    data = [...self.cricd, ...self.socd, ...self.tend, ...self.hord, ...self.gred];
  }
  var count = 0;
  $.each(data, function (a1, b1) {
    if (b === 1 && b1["Ct"]) {
      count++;
    } else if (b === 0 && !b1["Ct"]) {
      count++;
    } else if (b === 2) {
      count++;
    }
  });
  return count;
};
$$vm.calculatessnbooks = function () {
  var self = $$vm;
  self.allbooks = {};
  $.each(self.sbets, function (ii, jj) {
    var event = jj["Sn"];
    var ft = jj["Ft"];
    if (ft !== "CAS" || ft !== "PF") {
      var kk = self.allbooks[event];
      if (kk === undefined) {
        self.allbooks[event] = {};
      }
    }
  });
  $.each(self.allbooks, function (ii1, jj1) {
    self.calculatessnbooks1(ii1);
  });
  //console.log(self.allbooks);
};
$$vm.calculatessnbooks1 = function (b) {
  var self = $$vm;
  var min = 0;
  var max = 0;
  self.aracalcb = {};
  var ft = "";
  $.each(self.sbets, function (ii, jj) {
    if (jj["Sn"] === b) {
      var sid = jj["SId"];
      if (min === 0) {
        min = sid;
      } else if (sid < min) {
        min = sid;
      }
      if (max === 0) {
        max = sid;
      } else if (sid > max) {
        max = sid;
      }
      var kno = parseInt(jj["Kno"]);
      var r = jj["SId"];
      ft = jj["Ft"];
      if (jj["Ft"] === "KD" && max < r + kno * 2) {
        max = r + kno * 2;
        min = r - kno;
        if (min < 0) {
          min = 0;
        }
      }
      if (jj["Ft"] === "MTR" && max < r + 150) {
        max = r + 150;
      }
      if (jj["Ft"] === "MTR" && min > min - 150) {
        min = min - 150;
        if (min < 0) {
          min = 0;
        }
      }
    }
  });
  if (ft !== "MTR") {
    min -= 1;
    if (min < 0) {
      min = 0;
    }
    max += 1;
  }
  $.each(self.sbets, function (ii1, jj1) {
    var kno = parseInt(jj1["Kno"]);
    if (jj1["Sn"] === b) {
      var t = jj1["T"];
      //console.log(jj1);
      if (t === 2) {
        //jj["P"] = 
        //jj["L"] = 
      }
      var r = jj1["SId"];
      var pr = jj1["P"];
      var prr = jj1["P"];
      var li = jj1["L"];
      var lii = jj1["L"];
      if (t === 2) {
        for (var i = jj1["Ft"] === "MTR" ? r + 1 : r; i <= max; i++) {
          var book1 = self.aracalcb[i];
          if (jj1["Ft"] === "KD") {
            if (i >= r && i <= r + kno - 1) {
              if (book1 === undefined) self.aracalcb[i] = { i: i, p: jj1["P"] };
              else self.aracalcb[i] = { i: i, p: book1["p"] + jj1["P"] };
            } else {
              if (book1 === undefined) self.aracalcb[i] = { i: i, p: jj1["L"] };
              else self.aracalcb[i] = { i: i, p: book1["p"] + jj1["L"] };
            }
          } else if (jj1["Ft"] === "MTR") {
            if (book1 === undefined) self.aracalcb[i] = { i: i, p: pr };
            else self.aracalcb[i] = { i: i, p: book1["p"] + pr };
            pr += prr;
          } else {
            if (book1 === undefined) self.aracalcb[i] = { i: i, p: jj1["P"] };
            else self.aracalcb[i] = { i: i, p: book1["p"] + jj1["P"] };
          }
        }
        if (jj1["Ft"] === "MTR") {
          for (var ia = r - 1; ia >= min; ia--) {
            var book2 = self.aracalcb[ia];
            if (book2 === undefined) self.aracalcb[ia] = { i: ia, p: li };
            else self.aracalcb[ia] = { i: ia, p: book2["p"] + li };
            li += lii;
          }
        } else {
          for (var ia = min; ia < r; ia++) {
            var book2 = self.aracalcb[ia];
            if (book2 === undefined) self.aracalcb[ia] = { i: ia, p: jj1["L"] };
            else self.aracalcb[ia] = { i: ia, p: book2["p"] + jj1["L"] };
          }
        }
      } else {
        for (var ib = r; ib <= max; ib++) {
          if (jj1["Ft"] === "MTR") {
            var book1 = self.aracalcb[ib];
            if (book1 === undefined) self.aracalcb[ib] = { i: ib, p: li };
            else self.aracalcb[ib] = { i: ib, p: book1["p"] + li };
            li += lii;
          } else {
            var book3 = self.aracalcb[ib];
            if (book3 === undefined) self.aracalcb[ib] = { i: ib, p: jj1["L"] };
            else self.aracalcb[ib] = { i: ib, p: book3["p"] + jj1["L"] };
          }
        }
        if (jj1["Ft"] === "MTR") {
          for (var ic = r - 1; ic >= min; ic--) {
            var book1 = self.aracalcb[ic];
            if (book1 === undefined) self.aracalcb[ic] = { i: ic, p: pr };
            else self.aracalcb[ic] = { i: ic, p: book1["p"] + pr };
            pr += prr;
          }
        } else {
          for (var ic = min; ic < r; ic++) {
            var book4 = self.aracalcb[ic];
            if (book4 === undefined) self.aracalcb[ic] = { i: ic, p: jj1["P"] };
            else self.aracalcb[ic] = { i: ic, p: book4["p"] + jj1["P"] };
          }
        }
      }
    }
  });
  //self.aracalcb = self.aracalcb.sort(function (a, b) { return !a.N.localeCompare(b.i) });
  self.allbooks[b] = self.aracalcb;
};
$$vm.formatter = {
  date: function (value, format) {
    if (value) {
      return moment(String(value)).format(format || "MM/DD/YY");
    }
  },
  date1: function (value, format) {
    if (value) {
      return moment(String(value)).format(format || "MMM DD");
    }
  },
  time: function (value, format) {
    if (value) {
      return moment(String(value)).format(format || "h:mm A");
    }
  },
};
$$vm.gettype = function (t) {
  if (t === 1) {
    return "JackSnyder";
  } else if (t == 2) {
    return "AceAdmin";
  } else if (t == 3) {
    return "KingAdmin";
  } else if (t == 4) {
    return "QueenAdmin";
  } else if (t == 5) {
    return "JackAdmin";
  } else if (t == 6) {
    return "TenAdmin";
  } else if (t == 7) {
    return "NineAdmin";
  } else if (t == 8) {
    return "EightAdmin";
  } else if (t == 9) {
    return "WhiteLabel";
  } else if (t == 10) {
    return "SuperAdmin";
  } else if (t == 11) {
    return "Admin";
  } else if (t == 12) {
    return "Sub Company";
  } else if (t == 13) {
    return "Super Stockist";
  } else if (t == 14) {
    return "Stockist";
  } else if (t == 15) {
    return "Super Agent";
  } else if (t == 16) {
    return "Client";
  } else if (t == 99) {
    return "Referral";
  }
  return "JackSnyder";
};
$$vm.gettypeshort = function (t) {
  if (t === 1) {
    return "JS";
  } else if (t == 2) {
    return "AA";
  } else if (t == 3) {
    return "KA";
  } else if (t == 4) {
    return "QA";
  } else if (t == 5) {
    return "JA";
  } else if (t == 6) {
    return "TA";
  } else if (t == 7) {
    return "NA";
  } else if (t == 8) {
    return "EA";
  } else if (t == 9) {
    return "WL";
  } else if (t == 10) {
    return "SUB";
  } else if (t == 11) {
    return "ADM";
  } else if (t == 12) {
    return "SC";
  } else if (t == 13) {
    return "SST";
  } else if (t == 14) {
    return "SS";
  } else if (t == 15) {
    return "SA";
  } else if (t == 16) {
    return "SP";
  } else if (t == 99) {
    return "REF";
  }
  return "JS";
};
$$vm.getfullfancyname = function (a) {
  if (a === "F") {
    return "NORMAL";
  } else if (a === "OBO") {
    return "OVER";
  } else if (a === "BYB") {
    return "BALL";
  } else if (a === "KD") {
    return "KHADO";
  } else if (a === "MTR") {
    return "METER";
  } else if (a === "LM") {
    return "LINE MARKET";
  } else if (a === "B") {
    return "OVER FANCY";
  } else if (a === "F1") {
    return "FANCY1";
  } else if (a === "OE") {
    return "ODDEVEN";
  } else if (a === "PF") {
    return "PREMIUM FANCY";
  } else if (a === "CAS") {
    return "CASINO";
  }
  return a;
};
$$vm.initconn();
$$vm.datetimepicker = function (element) { element.kendoDateTimePicker(); }
$$vm.getusertyperange = function () {
  var ut = $$vm.bala.Ut;
  var res = [];
  if ($$vm.bala.Sl && ut !== 1) {
    res.push(ut);
  }
  for (let index = ut + 1; index <= 16; index++) {
    res.push(index);
  }
  return res;
};
app.directive("init", {
  bind: function (el, binding, vnode) {
    try {
      vnode.context[binding.expression]();
    } catch (e) { }
  },
});
app.directive("tooltip", Tooltip);
//app.use(router).use(PrimeVue).use(ToastService).use(Vue3Marquee).mount("#root");
app.use(router).use(PrimeVue, {
  theme: {
    preset: Lara,
    options: {
      cssLayer: false
    }
  }
}).use(Vue3Marquee).mount("#root");



// disableDevtool({url: window.location.origin + "/developer-tools"});

// !function(t,n){"object"==typeof exports&&"object"==typeof module?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports.devtoolsDetector=n():t.devtoolsDetector=n()}("undefined"!=typeof self?self:this,function(){return function(t){var n={};function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},e.p="",e(e.s=4)}([function(t,n,e){"use strict";e.d(n,"i",function(){return l}),e.d(n,"d",function(){return f}),e.d(n,"e",function(){return h}),e.d(n,"c",function(){return d}),e.d(n,"h",function(){return p}),e.d(n,"f",function(){return b}),e.d(n,"b",function(){return v}),e.d(n,"g",function(){return y}),e.d(n,"a",function(){return w});var r,o,i,u,c,a=e(3),s=Object(a.b)(),l=(null===(r=null===s||void 0===s?void 0:s.navigator)||void 0===r?void 0:r.userAgent)||"unknown",f="InstallTrigger"in((null===s||void 0===s?void 0:s.window)||{})||/firefox/i.test(l),h=/trident/i.test(l)||/msie/i.test(l),d=/edge/i.test(l),p=/webkit/i.test(l)&&!d,b=/IqiyiApp/.test(l),v=void 0!==(null===(o=null===s||void 0===s?void 0:s.window)||void 0===o?void 0:o.chrome)||/chrome/i.test(l)||/CriOS/i.test(l),y="[object SafariRemoteNotification]"===((null===(u=null===(i=null===s||void 0===s?void 0:s.window)||void 0===i?void 0:i.safari)||void 0===u?void 0:u.pushNotification)||!1).toString()||/safari/i.test(l)&&!v,w="function"==typeof(null===(c=s.document)||void 0===c?void 0:c.createElement)},function(t,n,e){"use strict";e.d(n,"b",function(){return i}),e.d(n,"c",function(){return u}),e.d(n,"a",function(){return c});var r=e(0);function o(t){if(console){if(!r.e&&!r.c)return console[t];if("log"===t||"clear"===t)return function(){for(var n=[],e=0;e<arguments.length;e++)n[e]=arguments[e];console[t].apply(console,n)}}return function(){for(var t=[],n=0;n<arguments.length;n++)t[n]=arguments[n]}}var i=o("log"),u=o("table"),c=o("clear")},function(t,n,e){"use strict";n.a=function(t){void 0===t&&(t={});for(var n=t.includes,e=void 0===n?[]:n,r=t.excludes,o=void 0===r?[]:r,i=!1,u=!1,c=0,a=e;c<a.length;c++){var s=a[c];if(!0===s){i=!0;break}}for(var l=0,f=o;l<f.length;l++){var s=f[l];if(!0===s){u=!0;break}}return i&&!u}},function(t,n,e){"use strict";(function(t){n.b=c,n.a=function(){for(var t,n=[],e=0;e<arguments.length;e++)n[e]=arguments[e];var r=c();if(null===r||void 0===r?void 0:r.document)return(t=r.document).createElement.apply(t,n);return{}},n.c=function(){if(r)return r;if(!a)return;var t=new Blob([o.a.workerScript]);try{var n=URL.createObjectURL(t);r=new o.a(new Worker(n)),URL.revokeObjectURL(n)}catch(t){try{r=new o.a(new Worker("data:text/javascript;base64,".concat(btoa(o.a.workerScript))))}catch(t){a=!1}}return r},e.d(n,"d",function(){return s});var r,o=e(10),i=this&&this.__awaiter||function(t,n,e,r){return new(e||(e=Promise))(function(o,i){function u(t){try{a(r.next(t))}catch(t){i(t)}}function c(t){try{a(r.throw(t))}catch(t){i(t)}}function a(t){t.done?o(t.value):function(t){return t instanceof e?t:new e(function(n){n(t)})}(t.value).then(u,c)}a((r=r.apply(t,n||[])).next())})},u=this&&this.__generator||function(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(c){return function(a){return function(c){if(e)throw new TypeError("Generator is already executing.");for(;i&&(i=0,c[0]&&(u=0)),u;)try{if(e=1,r&&(o=2&c[0]?r.return:c[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,c[1])).done)return o;switch(r=0,o&&(c=[2&c[0],o.value]),c[0]){case 0:case 1:o=c;break;case 4:return u.label++,{value:c[1],done:!1};case 5:u.label++,r=c[1],c=[0];continue;case 7:c=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===c[0]||2===c[0])){u=0;continue}if(3===c[0]&&(!o||c[1]>o[0]&&c[1]<o[3])){u.label=c[1];break}if(6===c[0]&&u.label<o[1]){u.label=o[1],o=c;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(c);break}o[2]&&u.ops.pop(),u.trys.pop();continue}c=n.call(t,u)}catch(t){c=[6,t],r=0}finally{e=o=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,a])}}};function c(){return"undefined"!=typeof self?self:"undefined"!=typeof window?window:void 0!==t?t:this}var a=!0;var s=function(){return i(this,void 0,void 0,function(){var t;return u(this,function(n){switch(n.label){case 0:if(t=!1,!navigator.brave)return[3,4];if(!navigator.brave.isBrave)return[3,4];n.label=1;case 1:return n.trys.push([1,3,,4]),[4,Promise.race([navigator.brave.isBrave(),new Promise(function(t){return setTimeout(function(){return t(!1)},1e3)})])];case 2:return t=n.sent(),[3,4];case 3:return n.sent(),[3,4];case 4:return s=function(){return i(this,void 0,void 0,function(){return u(this,function(n){return[2,t]})})},[2,t]}})})}}).call(n,e(9))},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.addListener=function(t){f.addListener(t)},n.removeListener=function(t){f.removeListener(t)},n.isLaunch=function(){return f.isLaunch()},n.launch=function(){f.launch()},n.stop=function(){f.stop()},n.setDetectDelay=function(t){f.setDetectDelay(t)};var r=e(8),o=e(12);e.d(n,"DevtoolsDetector",function(){return r.a}),e.d(n,"checkers",function(){return o});var i=e(2);e.d(n,"match",function(){return i.a});var u=e(3);e.d(n,"getGlobalThis",function(){return u.b}),e.d(n,"createElement",function(){return u.a}),e.d(n,"getWorkerConsole",function(){return u.c}),e.d(n,"isBrave",function(){return u.d});var c=e(23);e.d(n,"versionMap",function(){return c.a});var a=e(0);e.d(n,"userAgent",function(){return a.i}),e.d(n,"isFirefox",function(){return a.d}),e.d(n,"isIE",function(){return a.e}),e.d(n,"isEdge",function(){return a.c}),e.d(n,"isWebkit",function(){return a.h}),e.d(n,"isIqiyiApp",function(){return a.f}),e.d(n,"isChrome",function(){return a.b}),e.d(n,"isSafari",function(){return a.g}),e.d(n,"inBrowser",function(){return a.a});var s=e(1);e.d(n,"log",function(){return s.b}),e.d(n,"table",function(){return s.c}),e.d(n,"clear",function(){return s.a});var l=e(5);e.d(n,"isMac",function(){return l.d}),e.d(n,"isIpad",function(){return l.b}),e.d(n,"isIphone",function(){return l.c}),e.d(n,"isAndroid",function(){return l.a}),e.d(n,"isWindows",function(){return l.e});var f=new r.a({checkers:[o.erudaChecker,o.elementIdChecker,o.regToStringChecker,o.functionToStringChecker,o.depRegToStringChecker,o.dateToStringChecker,o.devtoolsFormatterChecker,o.performanceChecker,o.debuggerChecker]});n.default=f},function(t,n,e){"use strict";e.d(n,"d",function(){return o}),e.d(n,"b",function(){return i}),e.d(n,"c",function(){return u}),e.d(n,"a",function(){return c}),e.d(n,"e",function(){return a});var r=e(0),o=/macintosh/i.test(r.i),i=/ipad/i.test(r.i)||o&&navigator.maxTouchPoints>1,u=/iphone/i.test(r.i),c=/android/i.test(r.i),a=/windows/i.test(r.i)},function(t,n,e){"use strict";n.a=function(){return"undefined"!=typeof performance?performance.now():Date.now()}},function(t,n,e){"use strict";n.a=function(){null===r&&(r=function(){for(var t=function(){for(var t={},n=0;n<500;n++)t["".concat(n)]="".concat(n);return t}(),n=[],e=0;e<50;e++)n.push(t);return n}());return r};var r=null},function(t,n,e){"use strict";e.d(n,"a",function(){return u});var r=e(0),o=this&&this.__awaiter||function(t,n,e,r){return new(e||(e=Promise))(function(o,i){function u(t){try{a(r.next(t))}catch(t){i(t)}}function c(t){try{a(r.throw(t))}catch(t){i(t)}}function a(t){t.done?o(t.value):function(t){return t instanceof e?t:new e(function(n){n(t)})}(t.value).then(u,c)}a((r=r.apply(t,n||[])).next())})},i=this&&this.__generator||function(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(c){return function(a){return function(c){if(e)throw new TypeError("Generator is already executing.");for(;i&&(i=0,c[0]&&(u=0)),u;)try{if(e=1,r&&(o=2&c[0]?r.return:c[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,c[1])).done)return o;switch(r=0,o&&(c=[2&c[0],o.value]),c[0]){case 0:case 1:o=c;break;case 4:return u.label++,{value:c[1],done:!1};case 5:u.label++,r=c[1],c=[0];continue;case 7:c=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===c[0]||2===c[0])){u=0;continue}if(3===c[0]&&(!o||c[1]>o[0]&&c[1]<o[3])){u.label=c[1];break}if(6===c[0]&&u.label<o[1]){u.label=o[1],o=c;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(c);break}o[2]&&u.ops.pop(),u.trys.pop();continue}c=n.call(t,u)}catch(t){c=[6,t],r=0}finally{e=o=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,a])}}},u=function(){function t(t){var n=t.checkers;this._listeners=[],this._isOpen=!1,this._detectLoopStopped=!0,this._detectLoopDelay=500,this._checkers=n.slice()}return Object.defineProperty(t.prototype,"isOpen",{get:function(){return this._isOpen},enumerable:!1,configurable:!0}),t.prototype.launch=function(){r.a&&(this._detectLoopDelay<=0&&this.setDetectDelay(500),this._detectLoopStopped&&(this._detectLoopStopped=!1,this._detectLoop()))},t.prototype.stop=function(){this._detectLoopStopped||(this._detectLoopStopped=!0,this._isOpen=!1,clearTimeout(this._timer))},t.prototype.isLaunch=function(){return!this._detectLoopStopped},t.prototype.setDetectDelay=function(t){this._detectLoopDelay=t},t.prototype.addListener=function(t){this._listeners.push(t)},t.prototype.removeListener=function(t){this._listeners=this._listeners.filter(function(n){return n!==t})},t.prototype._broadcast=function(t){for(var n=0,e=this._listeners;n<e.length;n++){var r=e[n];try{r(t.isOpen,t)}catch(t){}}},t.prototype._detectLoop=function(){return o(this,void 0,void 0,function(){var t,n,e,r,o,u=this;return i(this,function(i){switch(i.label){case 0:t=!1,n="",e=0,r=this._checkers,i.label=1;case 1:return e<r.length?[4,(o=r[e]).isEnable()]:[3,6];case 2:return i.sent()?(n=o.name,[4,o.isOpen()]):[3,4];case 3:t=i.sent(),i.label=4;case 4:if(t)return[3,6];i.label=5;case 5:return e++,[3,1];case 6:return t!=this._isOpen&&(this._isOpen=t,this._broadcast({isOpen:t,checkerName:n})),this._detectLoopDelay>0&&!this._detectLoopStopped?this._timer=setTimeout(function(){return u._detectLoop()},this._detectLoopDelay):this.stop(),[2]}})})},t}()},function(t,n){var e;e=function(){return this}();try{e=e||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(e=window)}t.exports=e},function(t,n,e){"use strict";e.d(n,"a",function(){return c});var r=e(11),o=this&&this.__awaiter||function(t,n,e,r){return new(e||(e=Promise))(function(o,i){function u(t){try{a(r.next(t))}catch(t){i(t)}}function c(t){try{a(r.throw(t))}catch(t){i(t)}}function a(t){t.done?o(t.value):function(t){return t instanceof e?t:new e(function(n){n(t)})}(t.value).then(u,c)}a((r=r.apply(t,n||[])).next())})},i=this&&this.__generator||function(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(c){return function(a){return function(c){if(e)throw new TypeError("Generator is already executing.");for(;i&&(i=0,c[0]&&(u=0)),u;)try{if(e=1,r&&(o=2&c[0]?r.return:c[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,c[1])).done)return o;switch(r=0,o&&(c=[2&c[0],o.value]),c[0]){case 0:case 1:o=c;break;case 4:return u.label++,{value:c[1],done:!1};case 5:u.label++,r=c[1],c=[0];continue;case 7:c=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===c[0]||2===c[0])){u=0;continue}if(3===c[0]&&(!o||c[1]>o[0]&&c[1]<o[3])){u.label=c[1];break}if(6===c[0]&&u.label<o[1]){u.label=o[1],o=c;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(c);break}o[2]&&u.ops.pop(),u.trys.pop();continue}c=n.call(t,u)}catch(t){c=[6,t],r=0}finally{e=o=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,a])}}},u=this&&this.__spreadArray||function(t,n,e){if(e||2===arguments.length)for(var r,o=0,i=n.length;o<i;o++)!r&&o in n||(r||(r=Array.prototype.slice.call(n,0,o)),r[o]=n[o]);return t.concat(r||Array.prototype.slice.call(n))},c=function(){function t(t){var n=this;this.callbacks=new Map,this.worker=t,this.worker.onmessage=function(t){var e=t.data,r=e.id,o=n.callbacks.get(e.id);o&&(o({time:e.time}),n.callbacks.delete(r))},this.log=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];return n.send.apply(n,u(["log"],t,!1))},this.table=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];return n.send.apply(n,u(["table"],t,!1))},this.clear=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];return n.send.apply(n,u(["clear"],t,!1))}}return t.prototype.send=function(t){for(var n=[],e=1;e<arguments.length;e++)n[e-1]=arguments[e];return o(this,void 0,void 0,function(){var e,o=this;return i(this,function(i){return e=Object(r.a)(),[2,new Promise(function(r,i){o.callbacks.set(e,r),o.worker.postMessage({id:e,type:t,payload:n}),setTimeout(function(){i(new Error("timeout")),o.callbacks.delete(e)},2e3)})]})})},t.workerScript="\nonmessage = function(event) {\n  var action = event.data;\n  var startTime = performance.now()\n\n  console[action.type](...action.payload);\n  postMessage({\n    id: action.id,\n    time: performance.now() - startTime\n  })\n}\n",t}()},function(t,n,e){"use strict";n.a=function(){r>Number.MAX_SAFE_INTEGER&&(r=0);return r++};var r=0},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var r=e(13);e.d(n,"depRegToStringChecker",function(){return r.a});var o=e(14);e.d(n,"elementIdChecker",function(){return o.a});var i=e(15);e.d(n,"functionToStringChecker",function(){return i.a});var u=e(16);e.d(n,"regToStringChecker",function(){return u.a});var c=e(17);e.d(n,"debuggerChecker",function(){return c.a});var a=e(18);e.d(n,"dateToStringChecker",function(){return a.a});var s=e(19);e.d(n,"performanceChecker",function(){return s.a});var l=e(20);e.d(n,"erudaChecker",function(){return l.a});var f=e(21);e.d(n,"devtoolsFormatterChecker",function(){return f.a});var h=e(22);e.d(n,"workerPerformanceChecker",function(){return h.a})},function(t,n,e){"use strict";e.d(n,"a",function(){return l});var r=e(0),o=e(1),i=e(2),u=this&&this.__awaiter||function(t,n,e,r){return new(e||(e=Promise))(function(o,i){function u(t){try{a(r.next(t))}catch(t){i(t)}}function c(t){try{a(r.throw(t))}catch(t){i(t)}}function a(t){t.done?o(t.value):function(t){return t instanceof e?t:new e(function(n){n(t)})}(t.value).then(u,c)}a((r=r.apply(t,n||[])).next())})},c=this&&this.__generator||function(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(c){return function(a){return function(c){if(e)throw new TypeError("Generator is already executing.");for(;i&&(i=0,c[0]&&(u=0)),u;)try{if(e=1,r&&(o=2&c[0]?r.return:c[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,c[1])).done)return o;switch(r=0,o&&(c=[2&c[0],o.value]),c[0]){case 0:case 1:o=c;break;case 4:return u.label++,{value:c[1],done:!1};case 5:u.label++,r=c[1],c=[0];continue;case 7:c=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===c[0]||2===c[0])){u=0;continue}if(3===c[0]&&(!o||c[1]>o[0]&&c[1]<o[3])){u.label=c[1];break}if(6===c[0]&&u.label<o[1]){u.label=o[1],o=c;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(c);break}o[2]&&u.ops.pop(),u.trys.pop();continue}c=n.call(t,u)}catch(t){c=[6,t],r=0}finally{e=o=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,a])}}},a=/ /,s=!1;a.toString=function(){return s=!0,l.name};var l={name:"dep-reg-to-string",isOpen:function(){return u(this,void 0,void 0,function(){return c(this,function(t){return s=!1,Object(o.c)({dep:a}),Object(o.a)(),[2,s]})})},isEnable:function(){return u(this,void 0,void 0,function(){return c(this,function(t){return[2,Object(i.a)({includes:[!0],excludes:[r.d,r.e]})]})})}}},function(t,n,e){"use strict";e.d(n,"a",function(){return f});var r=e(0),o=e(1),i=e(2),u=e(3),c=this&&this.__awaiter||function(t,n,e,r){return new(e||(e=Promise))(function(o,i){function u(t){try{a(r.next(t))}catch(t){i(t)}}function c(t){try{a(r.throw(t))}catch(t){i(t)}}function a(t){t.done?o(t.value):function(t){return t instanceof e?t:new e(function(n){n(t)})}(t.value).then(u,c)}a((r=r.apply(t,n||[])).next())})},a=this&&this.__generator||function(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(c){return function(a){return function(c){if(e)throw new TypeError("Generator is already executing.");for(;i&&(i=0,c[0]&&(u=0)),u;)try{if(e=1,r&&(o=2&c[0]?r.return:c[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,c[1])).done)return o;switch(r=0,o&&(c=[2&c[0],o.value]),c[0]){case 0:case 1:o=c;break;case 4:return u.label++,{value:c[1],done:!1};case 5:u.label++,r=c[1],c=[0];continue;case 7:c=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===c[0]||2===c[0])){u=0;continue}if(3===c[0]&&(!o||c[1]>o[0]&&c[1]<o[3])){u.label=c[1];break}if(6===c[0]&&u.label<o[1]){u.label=o[1],o=c;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(c);break}o[2]&&u.ops.pop(),u.trys.pop();continue}c=n.call(t,u)}catch(t){c=[6,t],r=0}finally{e=o=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,a])}}},s=Object(u.a)("div"),l=!1;Object.defineProperty(s,"id",{get:function(){return l=!0,f.name},configurable:!0});var f={name:"element-id",isOpen:function(){return c(this,void 0,void 0,function(){return a(this,function(t){return l=!1,Object(o.b)(s),Object(o.a)(),[2,l]})})},isEnable:function(){return c(this,void 0,void 0,function(){return a(this,function(t){return[2,Object(i.a)({includes:[!0],excludes:[r.e,r.c,r.d]})]})})}}},function(t,n,e){"use strict";e.d(n,"a",function(){return f});var r=e(0),o=e(1),i=e(5),u=e(2),c=this&&this.__awaiter||function(t,n,e,r){return new(e||(e=Promise))(function(o,i){function u(t){try{a(r.next(t))}catch(t){i(t)}}function c(t){try{a(r.throw(t))}catch(t){i(t)}}function a(t){t.done?o(t.value):function(t){return t instanceof e?t:new e(function(n){n(t)})}(t.value).then(u,c)}a((r=r.apply(t,n||[])).next())})},a=this&&this.__generator||function(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(c){return function(a){return function(c){if(e)throw new TypeError("Generator is already executing.");for(;i&&(i=0,c[0]&&(u=0)),u;)try{if(e=1,r&&(o=2&c[0]?r.return:c[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,c[1])).done)return o;switch(r=0,o&&(c=[2&c[0],o.value]),c[0]){case 0:case 1:o=c;break;case 4:return u.label++,{value:c[1],done:!1};case 5:u.label++,r=c[1],c=[0];continue;case 7:c=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===c[0]||2===c[0])){u=0;continue}if(3===c[0]&&(!o||c[1]>o[0]&&c[1]<o[3])){u.label=c[1];break}if(6===c[0]&&u.label<o[1]){u.label=o[1],o=c;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(c);break}o[2]&&u.ops.pop(),u.trys.pop();continue}c=n.call(t,u)}catch(t){c=[6,t],r=0}finally{e=o=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,a])}}};function s(){}var l=0;s.toString=function(){return l++,""};var f={name:"function-to-string",isOpen:function(){return c(this,void 0,void 0,function(){return a(this,function(t){return l=0,Object(o.b)(s),Object(o.a)(),[2,2===l]})})},isEnable:function(){return c(this,void 0,void 0,function(){return a(this,function(t){return[2,Object(u.a)({includes:[!0],excludes:[r.f,r.d,(i.b||i.c)&&r.b]})]})})}}},function(t,n,e){"use strict";e.d(n,"a",function(){return l});var r=e(1),o=e(0),i=e(2),u=this&&this.__awaiter||function(t,n,e,r){return new(e||(e=Promise))(function(o,i){function u(t){try{a(r.next(t))}catch(t){i(t)}}function c(t){try{a(r.throw(t))}catch(t){i(t)}}function a(t){t.done?o(t.value):function(t){return t instanceof e?t:new e(function(n){n(t)})}(t.value).then(u,c)}a((r=r.apply(t,n||[])).next())})},c=this&&this.__generator||function(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(c){return function(a){return function(c){if(e)throw new TypeError("Generator is already executing.");for(;i&&(i=0,c[0]&&(u=0)),u;)try{if(e=1,r&&(o=2&c[0]?r.return:c[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,c[1])).done)return o;switch(r=0,o&&(c=[2&c[0],o.value]),c[0]){case 0:case 1:o=c;break;case 4:return u.label++,{value:c[1],done:!1};case 5:u.label++,r=c[1],c=[0];continue;case 7:c=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===c[0]||2===c[0])){u=0;continue}if(3===c[0]&&(!o||c[1]>o[0]&&c[1]<o[3])){u.label=c[1];break}if(6===c[0]&&u.label<o[1]){u.label=o[1],o=c;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(c);break}o[2]&&u.ops.pop(),u.trys.pop();continue}c=n.call(t,u)}catch(t){c=[6,t],r=0}finally{e=o=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,a])}}},a=/ /,s=!1;a.toString=function(){return s=!0,l.name};var l={name:"reg-to-string",isOpen:function(){return u(this,void 0,void 0,function(){return c(this,function(t){return s=!1,Object(r.b)(a),Object(r.a)(),[2,s]})})},isEnable:function(){return u(this,void 0,void 0,function(){return c(this,function(t){return[2,Object(i.a)({includes:[!0],excludes:[o.h]})]})})}}},function(t,n,e){"use strict";e.d(n,"a",function(){return u});var r=e(6),o=this&&this.__awaiter||function(t,n,e,r){return new(e||(e=Promise))(function(o,i){function u(t){try{a(r.next(t))}catch(t){i(t)}}function c(t){try{a(r.throw(t))}catch(t){i(t)}}function a(t){t.done?o(t.value):function(t){return t instanceof e?t:new e(function(n){n(t)})}(t.value).then(u,c)}a((r=r.apply(t,n||[])).next())})},i=this&&this.__generator||function(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(c){return function(a){return function(c){if(e)throw new TypeError("Generator is already executing.");for(;i&&(i=0,c[0]&&(u=0)),u;)try{if(e=1,r&&(o=2&c[0]?r.return:c[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,c[1])).done)return o;switch(r=0,o&&(c=[2&c[0],o.value]),c[0]){case 0:case 1:o=c;break;case 4:return u.label++,{value:c[1],done:!1};case 5:u.label++,r=c[1],c=[0];continue;case 7:c=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===c[0]||2===c[0])){u=0;continue}if(3===c[0]&&(!o||c[1]>o[0]&&c[1]<o[3])){u.label=c[1];break}if(6===c[0]&&u.label<o[1]){u.label=o[1],o=c;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(c);break}o[2]&&u.ops.pop(),u.trys.pop();continue}c=n.call(t,u)}catch(t){c=[6,t],r=0}finally{e=o=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,a])}}},u={name:"debugger-checker",isOpen:function(){return o(this,void 0,void 0,function(){var t;return i(this,function(n){return t=Object(r.a)(),function(){}.constructor("debugger")(),[2,Object(r.a)()-t>100]})})},isEnable:function(){return o(this,void 0,void 0,function(){return i(this,function(t){return[2,!0]})})}}},function(t,n,e){"use strict";e.d(n,"a",function(){return f});var r=e(0),o=e(1),i=e(2),u=e(4),c=this&&this.__awaiter||function(t,n,e,r){return new(e||(e=Promise))(function(o,i){function u(t){try{a(r.next(t))}catch(t){i(t)}}function c(t){try{a(r.throw(t))}catch(t){i(t)}}function a(t){t.done?o(t.value):function(t){return t instanceof e?t:new e(function(n){n(t)})}(t.value).then(u,c)}a((r=r.apply(t,n||[])).next())})},a=this&&this.__generator||function(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(c){return function(a){return function(c){if(e)throw new TypeError("Generator is already executing.");for(;i&&(i=0,c[0]&&(u=0)),u;)try{if(e=1,r&&(o=2&c[0]?r.return:c[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,c[1])).done)return o;switch(r=0,o&&(c=[2&c[0],o.value]),c[0]){case 0:case 1:o=c;break;case 4:return u.label++,{value:c[1],done:!1};case 5:u.label++,r=c[1],c=[0];continue;case 7:c=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===c[0]||2===c[0])){u=0;continue}if(3===c[0]&&(!o||c[1]>o[0]&&c[1]<o[3])){u.label=c[1];break}if(6===c[0]&&u.label<o[1]){u.label=o[1],o=c;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(c);break}o[2]&&u.ops.pop(),u.trys.pop();continue}c=n.call(t,u)}catch(t){c=[6,t],r=0}finally{e=o=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,a])}}},s=new Date,l=0;s.toString=function(){return l++,""};var f={name:"date-to-string",isOpen:function(){return c(this,void 0,void 0,function(){return a(this,function(t){return l=0,Object(o.b)(s),Object(o.a)(),[2,2===l]})})},isEnable:function(){return c(this,void 0,void 0,function(){return a(this,function(t){return[2,Object(i.a)({includes:[r.b],excludes:[(u.isIpad||u.isIphone)&&r.b]})]})})}}},function(t,n,e){"use strict";e.d(n,"a",function(){return h});var r=e(1),o=e(0),i=e(7),u=e(2),c=e(3),a=e(6),s=this&&this.__awaiter||function(t,n,e,r){return new(e||(e=Promise))(function(o,i){function u(t){try{a(r.next(t))}catch(t){i(t)}}function c(t){try{a(r.throw(t))}catch(t){i(t)}}function a(t){t.done?o(t.value):function(t){return t instanceof e?t:new e(function(n){n(t)})}(t.value).then(u,c)}a((r=r.apply(t,n||[])).next())})},l=this&&this.__generator||function(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(c){return function(a){return function(c){if(e)throw new TypeError("Generator is already executing.");for(;i&&(i=0,c[0]&&(u=0)),u;)try{if(e=1,r&&(o=2&c[0]?r.return:c[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,c[1])).done)return o;switch(r=0,o&&(c=[2&c[0],o.value]),c[0]){case 0:case 1:o=c;break;case 4:return u.label++,{value:c[1],done:!1};case 5:u.label++,r=c[1],c=[0];continue;case 7:c=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===c[0]||2===c[0])){u=0;continue}if(3===c[0]&&(!o||c[1]>o[0]&&c[1]<o[3])){u.label=c[1];break}if(6===c[0]&&u.label<o[1]){u.label=o[1],o=c;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(c);break}o[2]&&u.ops.pop(),u.trys.pop();continue}c=n.call(t,u)}catch(t){c=[6,t],r=0}finally{e=o=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,a])}}},f=0,h={name:"performance",isOpen:function(){return s(this,void 0,void 0,function(){var t,n;return l(this,function(e){switch(e.label){case 0:return t=function(){var t=Object(i.a)(),n=Object(a.a)();return Object(r.c)(t),Object(a.a)()-n}(),n=Math.max(d(),d()),f=Math.max(f,n),Object(r.a)(),0===t?[2,!1]:0!==f?[3,2]:[4,Object(c.d)()];case 1:return e.sent()?[2,!0]:[2,!1];case 2:return[2,t>10*f]}})})},isEnable:function(){return s(this,void 0,void 0,function(){return l(this,function(t){return[2,Object(u.a)({includes:[o.b],excludes:[]})]})})}};function d(){var t=Object(i.a)(),n=Object(a.a)();return Object(r.b)(t),Object(a.a)()-n}},function(t,n,e){"use strict";e.d(n,"a",function(){return i});var r=this&&this.__awaiter||function(t,n,e,r){return new(e||(e=Promise))(function(o,i){function u(t){try{a(r.next(t))}catch(t){i(t)}}function c(t){try{a(r.throw(t))}catch(t){i(t)}}function a(t){t.done?o(t.value):function(t){return t instanceof e?t:new e(function(n){n(t)})}(t.value).then(u,c)}a((r=r.apply(t,n||[])).next())})},o=this&&this.__generator||function(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(c){return function(a){return function(c){if(e)throw new TypeError("Generator is already executing.");for(;i&&(i=0,c[0]&&(u=0)),u;)try{if(e=1,r&&(o=2&c[0]?r.return:c[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,c[1])).done)return o;switch(r=0,o&&(c=[2&c[0],o.value]),c[0]){case 0:case 1:o=c;break;case 4:return u.label++,{value:c[1],done:!1};case 5:u.label++,r=c[1],c=[0];continue;case 7:c=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===c[0]||2===c[0])){u=0;continue}if(3===c[0]&&(!o||c[1]>o[0]&&c[1]<o[3])){u.label=c[1];break}if(6===c[0]&&u.label<o[1]){u.label=o[1],o=c;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(c);break}o[2]&&u.ops.pop(),u.trys.pop();continue}c=n.call(t,u)}catch(t){c=[6,t],r=0}finally{e=o=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,a])}}},i={name:"eruda",isOpen:function(){var t;return r(this,void 0,void 0,function(){return o(this,function(n){return"undefined"!=typeof eruda?[2,!0===(null===(t=null===eruda||void 0===eruda?void 0:eruda._devTools)||void 0===t?void 0:t._isShow)]:[2,!1]})})},isEnable:function(){return r(this,void 0,void 0,function(){return o(this,function(t){return[2,!0]})})}}},function(t,n,e){"use strict";e.d(n,"a",function(){return a});var r=e(1),o=this&&this.__awaiter||function(t,n,e,r){return new(e||(e=Promise))(function(o,i){function u(t){try{a(r.next(t))}catch(t){i(t)}}function c(t){try{a(r.throw(t))}catch(t){i(t)}}function a(t){t.done?o(t.value):function(t){return t instanceof e?t:new e(function(n){n(t)})}(t.value).then(u,c)}a((r=r.apply(t,n||[])).next())})},i=this&&this.__generator||function(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(c){return function(a){return function(c){if(e)throw new TypeError("Generator is already executing.");for(;i&&(i=0,c[0]&&(u=0)),u;)try{if(e=1,r&&(o=2&c[0]?r.return:c[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,c[1])).done)return o;switch(r=0,o&&(c=[2&c[0],o.value]),c[0]){case 0:case 1:o=c;break;case 4:return u.label++,{value:c[1],done:!1};case 5:u.label++,r=c[1],c=[0];continue;case 7:c=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===c[0]||2===c[0])){u=0;continue}if(3===c[0]&&(!o||c[1]>o[0]&&c[1]<o[3])){u.label=c[1];break}if(6===c[0]&&u.label<o[1]){u.label=o[1],o=c;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(c);break}o[2]&&u.ops.pop(),u.trys.pop();continue}c=n.call(t,u)}catch(t){c=[6,t],r=0}finally{e=o=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,a])}}},u=!1,c={header:function(){return u=!0,null}},a={name:"DevtoolsFormatters",isOpen:function(){return o(this,void 0,void 0,function(){return i(this,function(t){return window.devtoolsFormatters?-1===window.devtoolsFormatters.indexOf(c)&&window.devtoolsFormatters.push(c):window.devtoolsFormatters=[c],u=!1,Object(r.b)({}),Object(r.a)(),[2,u]})})},isEnable:function(){return o(this,void 0,void 0,function(){return i(this,function(t){return[2,!0]})})}}},function(t,n,e){"use strict";e.d(n,"a",function(){return l});var r=e(0),o=e(2),i=e(3),u=e(7),c=this&&this.__awaiter||function(t,n,e,r){return new(e||(e=Promise))(function(o,i){function u(t){try{a(r.next(t))}catch(t){i(t)}}function c(t){try{a(r.throw(t))}catch(t){i(t)}}function a(t){t.done?o(t.value):function(t){return t instanceof e?t:new e(function(n){n(t)})}(t.value).then(u,c)}a((r=r.apply(t,n||[])).next())})},a=this&&this.__generator||function(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(c){return function(a){return function(c){if(e)throw new TypeError("Generator is already executing.");for(;i&&(i=0,c[0]&&(u=0)),u;)try{if(e=1,r&&(o=2&c[0]?r.return:c[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,c[1])).done)return o;switch(r=0,o&&(c=[2&c[0],o.value]),c[0]){case 0:case 1:o=c;break;case 4:return u.label++,{value:c[1],done:!1};case 5:u.label++,r=c[1],c=[0];continue;case 7:c=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===c[0]||2===c[0])){u=0;continue}if(3===c[0]&&(!o||c[1]>o[0]&&c[1]<o[3])){u.label=c[1];break}if(6===c[0]&&u.label<o[1]){u.label=o[1],o=c;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(c);break}o[2]&&u.ops.pop(),u.trys.pop();continue}c=n.call(t,u)}catch(t){c=[6,t],r=0}finally{e=o=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,a])}}},s=0,l={name:"worker-performance",isOpen:function(){return c(this,void 0,void 0,function(){var t,n,e;return a(this,function(r){switch(r.label){case 0:return null==(t=Object(i.c)())?[2,!1]:[4,function(t){return c(this,void 0,void 0,function(){var n;return a(this,function(e){switch(e.label){case 0:return n=Object(u.a)(),[4,t.table(n)];case 1:return[2,e.sent().time]}})})}(t)];case 1:return n=r.sent(),[4,function(t){return c(this,void 0,void 0,function(){var n;return a(this,function(e){switch(e.label){case 0:return n=Object(u.a)(),[4,t.log(n)];case 1:return[2,e.sent().time]}})})}(t)];case 2:return e=r.sent(),s=Math.max(s,e),[4,t.clear()];case 3:return r.sent(),0===n?[2,!1]:0!==s?[3,5]:[4,Object(i.d)()];case 4:return r.sent()?[2,!0]:[2,!1];case 5:return[2,n>10*s]}})})},isEnable:function(){return c(this,void 0,void 0,function(){return a(this,function(t){return[2,Object(o.a)({includes:[r.b],excludes:[]})]})})}}},function(t,n,e){"use strict";e.d(n,"a",function(){return r});for(var r={},o=0,i=(e(0).i||"").match(/\w+\/(\d|\.)+(\s|$)/gi)||[];o<i.length;o++){var u=i[o].split("/"),c=u[0],a=u[1];r[c]=a}}])});
//  function handleDevtoolsAndIframe() {
//    devtoolsDetector.addListener(function(isOpen) {
//      if (isOpen) {
//        window.location.replace(window.location.origin + "/developer-tools");
//      }
//    });
//    devtoolsDetector.launch();
//  }
//  handleDevtoolsAndIframe();

$(document).ready(function () {
  (function ($) {
    "use strict";

    // Spinner
    var spinner = function () {
      setTimeout(function () {
        if ($('#spinner').length > 0) {
          $('#spinner').removeClass('show');
        }
      }, 1);
    };
    spinner();


    // Back to top button
    $(window).scroll(function () {
      if ($(this).scrollTop() > 300) {
        $('.back-to-top').fadeIn('slow');
      } else {
        $('.back-to-top').fadeOut('slow');
      }
    });
    $('.back-to-top').click(function () {
      $('html, body').animate({ scrollTop: 0 }, 1500, 'easeInOutExpo');
      return false;
    });


    // Sidebar Toggler
    $('.sidebar-toggler').on("click", function () {
      $('.sidebar, .content').toggleClass("open");
      return false;
    });


    // // Progress Bar
    // $('.pg-bar').waypoint(function () {
    //     $('.progress .progress-bar').each(function () {
    //         $(this).css("width", $(this).attr("aria-valuenow") + '%');
    //     });
    // }, {offset: '80%'});


    // // Calender
    // $('#calender').datetimepicker({
    //     inline: true,
    //     format: 'L'
    // });


    // // Testimonials carousel
    // $(".testimonial-carousel").owlCarousel({
    //     autoplay: true,
    //     smartSpeed: 1000,
    //     items: 1,
    //     dots: true,
    //     loop: true,
    //     nav : false
    // });


    // // Worldwide Sales Chart
    // var ctx1 = $("#worldwide-sales").get(0).getContext("2d");
    // var myChart1 = new Chart(ctx1, {
    //     type: "bar",
    //     data: {
    //         labels: ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    //         datasets: [{
    //                 label: "USA",
    //                 data: [15, 30, 55, 65, 60, 80, 95],
    //                 backgroundColor: "rgba(0, 156, 255, .7)"
    //             },
    //             {
    //                 label: "UK",
    //                 data: [8, 35, 40, 60, 70, 55, 75],
    //                 backgroundColor: "rgba(0, 156, 255, .5)"
    //             },
    //             {
    //                 label: "AU",
    //                 data: [12, 25, 45, 55, 65, 70, 60],
    //                 backgroundColor: "rgba(0, 156, 255, .3)"
    //             }
    //         ]
    //         },
    //     options: {
    //         responsive: true
    //     }
    // });


    // // Salse & Revenue Chart
    // var ctx2 = $("#salse-revenue").get(0).getContext("2d");
    // var myChart2 = new Chart(ctx2, {
    //     type: "line",
    //     data: {
    //         labels: ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    //         datasets: [{
    //                 label: "Salse",
    //                 data: [15, 30, 55, 45, 70, 65, 85],
    //                 backgroundColor: "rgba(0, 156, 255, .5)",
    //                 fill: true
    //             },
    //             {
    //                 label: "Revenue",
    //                 data: [99, 135, 170, 130, 190, 180, 270],
    //                 backgroundColor: "rgba(0, 156, 255, .3)",
    //                 fill: true
    //             }
    //         ]
    //         },
    //     options: {
    //         responsive: true
    //     }
    // });



    // // Single Line Chart
    // var ctx3 = $("#line-chart").get(0).getContext("2d");
    // var myChart3 = new Chart(ctx3, {
    //     type: "line",
    //     data: {
    //         labels: [50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150],
    //         datasets: [{
    //             label: "Salse",
    //             fill: false,
    //             backgroundColor: "rgba(0, 156, 255, .3)",
    //             data: [7, 8, 8, 9, 9, 9, 10, 11, 14, 14, 15]
    //         }]
    //     },
    //     options: {
    //         responsive: true
    //     }
    // });


    // // Single Bar Chart
    // var ctx4 = $("#bar-chart").get(0).getContext("2d");
    // var myChart4 = new Chart(ctx4, {
    //     type: "bar",
    //     data: {
    //         labels: ["Italy", "France", "Spain", "USA", "Argentina"],
    //         datasets: [{
    //             backgroundColor: [
    //                 "rgba(0, 156, 255, .7)",
    //                 "rgba(0, 156, 255, .6)",
    //                 "rgba(0, 156, 255, .5)",
    //                 "rgba(0, 156, 255, .4)",
    //                 "rgba(0, 156, 255, .3)"
    //             ],
    //             data: [55, 49, 44, 24, 15]
    //         }]
    //     },
    //     options: {
    //         responsive: true
    //     }
    // });


    // // Pie Chart
    // var ctx5 = $("#pie-chart").get(0).getContext("2d");
    // var myChart5 = new Chart(ctx5, {
    //     type: "pie",
    //     data: {
    //         labels: ["Italy", "France", "Spain", "USA", "Argentina"],
    //         datasets: [{
    //             backgroundColor: [
    //                 "rgba(0, 156, 255, .7)",
    //                 "rgba(0, 156, 255, .6)",
    //                 "rgba(0, 156, 255, .5)",
    //                 "rgba(0, 156, 255, .4)",
    //                 "rgba(0, 156, 255, .3)"
    //             ],
    //             data: [55, 49, 44, 24, 15]
    //         }]
    //     },
    //     options: {
    //         responsive: true
    //     }
    // });


    // // Doughnut Chart
    // var ctx6 = $("#doughnut-chart").get(0).getContext("2d");
    // var myChart6 = new Chart(ctx6, {
    //     type: "doughnut",
    //     data: {
    //         labels: ["Italy", "France", "Spain", "USA", "Argentina"],
    //         datasets: [{
    //             backgroundColor: [
    //                 "rgba(0, 156, 255, .7)",
    //                 "rgba(0, 156, 255, .6)",
    //                 "rgba(0, 156, 255, .5)",
    //                 "rgba(0, 156, 255, .4)",
    //                 "rgba(0, 156, 255, .3)"
    //             ],
    //             data: [55, 49, 44, 24, 15]
    //         }]
    //     },
    //     options: {
    //         responsive: true
    //     }
    // });


  })(jQuery);
});


